import React from 'react';
import { Star } from 'lucide-react';

interface ServiceProfileMetaBadgesProps {
  displayRating: string;
  reviewCount: number;
  categoryList: string[];
  joinedDate?: string;
}

export const ServiceProfileMetaBadges: React.FC<ServiceProfileMetaBadgesProps> = ({
  displayRating,
  reviewCount,
  categoryList,
  joinedDate,
}) => {
  return (
    <div className="grid gap-y-4 border-y border-brand-cloud py-5 md:grid-cols-[minmax(0,0.28fr)_minmax(0,0.72fr)] md:gap-x-8">
      <h3 className="public-card-title">Rating</h3>
      <div className="flex items-center leading-7 text-brand-slate">
        <Star className="mr-1.5 h-4 w-4 fill-amber text-amber" />
        <span className="font-semibold text-brand-ink">{displayRating}</span>
        <span className="ml-1">({reviewCount} {reviewCount === 1 ? 'review' : 'reviews'})</span>
      </div>

      <h3 className="public-card-title">Categories</h3>
      <p className="leading-7 text-brand-slate">
        {categoryList.length > 0 ? categoryList.map((category, index) => (
          <React.Fragment key={category}>
            <span>{category}</span>
            {index < categoryList.length - 1 && <span className="text-brand-slate">, </span>}
          </React.Fragment>
        )) : "Not specified"}
      </p>

      {joinedDate && (
        <>
          <h3 className="public-card-title">Member since</h3>
          <p className="leading-7 text-brand-slate">{joinedDate}</p>
        </>
      )}
    </div>
  );
};
